<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium (Padrão Validade de Lotes) -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3 bg-white border-bottom">
        <div class="d-flex align-items-center p-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
            <i class="fa fa-bar-chart text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold text-dark">Análise de Custos</h4>
            <small class="text-muted mb-0 d-none d-lg-block">Visão Estratégica de Estoque e Produção</small>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3 w-100 w-md-auto justify-content-end">
          <!-- Botões de Exportação -->
          <b-button-group class="mr-2 d-none d-lg-inline-flex bg-light rounded-pill p-1 shadow-xs border">
            <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
              <i class="fa fa-file-excel-o"></i>
            </b-button>
            <b-button variant="link" class="btn-icon-only text-muted" @click="imprimirListagem()" v-b-tooltip.hover title="Imprimir Listagem">
              <i class="fa fa-print"></i>
            </b-button>
          </b-button-group>

          <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
            <div class="d-flex align-items-center px-2 border-right mr-2">
              <label class="mb-0 mr-2 small text-muted">INÍCIO:</label>
              <b-form-input type="date" v-model="filtros.dt1" class="bg-transparent border-0 p-0" :style="{ width: '130px', fontSize: '0.85rem' }"></b-form-input>
            </div>
            <div class="d-flex align-items-center px-2 mr-2">
              <label class="mb-0 mr-2 small text-muted">FIM:</label>
              <b-form-input type="date" v-model="filtros.dt2" class="bg-transparent border-0 p-0" :style="{ width: '130px', fontSize: '0.85rem' }"></b-form-input>
            </div>
            <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white" :disabled="loading" @click="carregarDados()">
              <i class="fa fa-search mr-1"></i> <span class="d-none d-sm-inline">FILTRAR</span>
            </b-button>
          </div>
        </div>
      </div>

      <!-- Resumo Analítico -->
      <b-row class="mb-4 px-3">
        <b-col md="4" sm="6" class="mb-3">
          <div class="card border-0 shadow-sm rounded-lg overflow-hidden h-100 border-left-primary">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="text-muted mb-1 text-uppercase small font-weight-bold">Valor Total em Estoque</p>
                  <h4 class="text-dark mb-0 font-weight-bold">{{ formatarMoeda(resumo.valorTotalEstoque) }}</h4>
                </div>
                <div class="icon-circle bg-primary-soft">
                  <i class="fa fa-money text-primary"></i>
                </div>
              </div>
              <div class="mt-2">
                <small class="text-muted"><i class="fa fa-cube mr-1"></i> {{ resumo.totalProdutosEstoque }} Itens com Saldo</small>
              </div>
            </div>
          </div>
        </b-col>
        <b-col md="4" sm="6" class="mb-3">
          <div class="card border-0 shadow-sm rounded-lg overflow-hidden h-100 border-left-success">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="text-muted mb-1 text-uppercase small font-weight-bold">Produzido no Período</p>
                  <h4 class="text-dark mb-0 font-weight-bold">{{ formatarMoeda(resumo.valorTotalProduzido) }}</h4>
                </div>
                <div class="icon-circle bg-success-soft">
                  <i class="fa fa-industry text-success"></i>
                </div>
              </div>
              <div class="mt-2">
                <small class="text-muted"><i class="fa fa-check-circle mr-1"></i> {{ resumo.totalProcessosFinalizados }} Processos</small>
              </div>
            </div>
          </div>
        </b-col>
        <b-col md="4" sm="12" class="mb-3">
          <div class="card border-0 shadow-sm rounded-lg overflow-hidden h-100 border-left-warning">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="text-muted mb-1 text-uppercase small font-weight-bold">Custo Operacional</p>
                  <h4 class="text-dark mb-0 font-weight-bold">{{ formatarMoeda(resumo.valorCustoOperacional) }}</h4>
                </div>
                <div class="icon-circle bg-warning-soft">
                  <i class="fa fa-cogs text-warning"></i>
                </div>
              </div>
              <div class="mt-2">
                <small class="text-muted"><i class="fa fa-pie-chart mr-1"></i> {{ formatarPercentual(resumo.percentualCustoOp) }} do Total</small>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>

      <!-- Gráficos -->
      <b-row class="mb-4 px-3">
        <b-col md="6" class="mb-3">
          <div class="card border-0 shadow-sm rounded-lg h-100">
            <div class="card-header bg-white border-bottom-0 pt-3">
              <h6 class="m-0 font-weight-bold text-dark">Valorização por Grupo</h6>
            </div>
            <div class="card-body">
              <div id="chartGrupo" style="height: 300px;"></div>
            </div>
          </div>
        </b-col>
        <b-col md="6" class="mb-3">
          <div class="card border-0 shadow-sm rounded-lg h-100">
            <div class="card-header bg-white border-bottom-0 pt-3">
              <h6 class="m-0 font-weight-bold text-dark">Valorização por Centro</h6>
            </div>
            <div class="card-body">
              <div id="chartCentro" style="height: 300px;"></div>
            </div>
          </div>
        </b-col>
      </b-row>

      <!-- Tabela -->
      <b-row class="px-3">
        <b-col cols="12">
          <div class="card border-0 shadow-sm rounded-lg overflow-hidden">
            <div class="card-header bg-white border-bottom-0 pt-3 d-flex justify-content-between align-items-center">
              <h6 class="m-0 font-weight-bold text-dark">Histórico de Custos de Produção</h6>
              <div class="d-flex align-items-center">
                <b-button variant="outline-primary" size="sm" class="mr-2 rounded-pill" @click="imprimirListagem">
                  <i class="fa fa-print mr-1"></i> Imprimir Listagem
                </b-button>
                <b-dropdown variant="outline-secondary" size="sm" right no-caret toggle-class="rounded-pill px-3">
                  <template #button-content>
                    <i class="fa fa-download mr-1"></i> Exportar
                  </template>
                  <b-dropdown-item @click="exportarExcel"><i class="fa fa-file-excel-o mr-2 text-success"></i> Excel</b-dropdown-item>
                  <b-dropdown-item @click="exportarCsv"><i class="fa fa-file-code-o mr-2 text-info"></i> CSV</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <div class="card-body p-0">
              <div class="table-responsive">
                <table class="table table-hover mb-0" style="font-size: 0.9rem;">
                  <thead class="bg-light">
                    <tr>
                      <th>ID</th>
                      <th>Produto Acabado</th>
                      <th>Finalização</th>
                      <th class="text-right">Qtd Produzida</th>
                      <th class="text-right">Custo Insumos</th>
                      <th class="text-right">Custo Operacional</th>
                      <th class="text-right">Custo Total</th>
                      <th class="text-right">Unitário Real</th>
                      <th class="text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loading">
                      <td colspan="9" class="text-center py-4">
                        <b-spinner label="Spinning" variant="primary"></b-spinner>
                      </td>
                    </tr>
                    <tr v-else-if="historicoProducao.length === 0">
                      <td colspan="9" class="text-center py-4 text-muted">Nenhum registro encontrado.</td>
                    </tr>
                    <tr v-for="item in historicoProducao" :key="item.PROCESSO_ID">
                      <td><span class="badge badge-light">#{{ item.PROCESSO_ID }}</span></td>
                      <td class="font-weight-bold">{{ item.PRODUTO_ACABADO }}</td>
                      <td>{{ formatarData(item.DATA_FINALIZACAO) }}</td>
                      <td class="text-right">{{ formatarQuantidade(item.QUANT_PRODUZIDA) }}</td>
                      <td class="text-right text-info font-weight-bold">{{ formatarMoeda(item.CUSTO_INSUMOS) }}</td>
                      <td class="text-right text-warning font-weight-bold">{{ formatarMoeda(item.CUSTO_OPERACIONAL) }}</td>
                      <td class="text-right text-dark font-weight-bold">{{ formatarMoeda(item.CUSTO_INSUMOS + item.CUSTO_OPERACIONAL) }}</td>
                      <td class="text-right">
                        <span class="badge badge-success px-2 py-1">
                          {{ formatarMoeda((item.CUSTO_INSUMOS + item.CUSTO_OPERACIONAL) / (item.QUANT_PRODUZIDA || 1)) }}
                        </span>
                      </td>
                      <td class="text-center">
                        <b-button variant="link" size="sm" class="text-primary p-0" v-b-tooltip.hover title="Ver Detalhes" @click="abrirEspelhoCusto(item)">
                          <i class="fa fa-search-plus"></i>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- Modal de Detalhamento de Custo Real -->
      <b-modal 
        ref="modalDetalhe" 
        id="modal-detalhe-custo"
        size="xl" 
        hide-footer 
        centered
        body-class="p-0"
        modal-class="premium-modal">
        <template #modal-header>
          <div class="bg-gradient-info w-100 p-3 d-flex align-items-center justify-content-between text-white" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);">
            <div class="d-flex align-items-center">
              <div class="bg-white-20 rounded-circle p-2 mr-3" style="background: rgba(255,255,255,0.2);">
                <i class="fa fa-search-plus text-white"></i>
              </div>
              <div>
                <h5 class="mb-0 font-weight-bold">Detalhamento de Custo Real</h5>
                <small class="text-white-50">Análise detalhada de insumos e rateios operacionais</small>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <b-button v-if="detalheSelecionado" variant="link" class="btn-glass text-white border-white-50 py-1 px-3 mr-3 rounded-pill border" @click="imprimirEspelhoCusto(detalheSelecionado)">
                <i class="fa fa-print mr-1"></i> ESPELHO A4
              </b-button>
              <button type="button" class="close text-white" @click="$refs.modalDetalhe.hide()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </template>

        <div class="p-4" v-if="detalheSelecionado">
          <div class="row mb-4">
            <div class="col-md-3">
              <div class="p-3 bg-light rounded border shadow-xs h-100 border-left-info">
                <small class="text-muted d-block text-uppercase font-weight-bold mb-1" style="font-size: 10px;">Processo</small>
                <h5 class="mb-0 font-weight-bold text-dark">#{{ detalheSelecionado.processo.ID }}</h5>
                <div class="mt-2 badge badge-info badge-pill">{{ detalheSelecionado.processo.LOTE }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="p-3 bg-light rounded border shadow-xs h-100">
                <small class="text-muted d-block text-uppercase font-weight-bold mb-1" style="font-size: 10px;">Produto Acabado</small>
                <h5 class="mb-0 font-weight-bold text-dark">{{ detalheSelecionado.processo.PRODUTO_NOME }}</h5>
                <small class="text-muted">Ref: {{ formatarData(detalheSelecionado.processo.DATA_FINALIZACAO || detalheSelecionado.processo.DATA_PROCESSO) }}</small>
              </div>
            </div>
            <div class="col-md-3">
              <div class="p-3 bg-primary text-white rounded border shadow-xs h-100" style="background: #4e73df;">
                <small class="text-white-50 d-block text-uppercase font-weight-bold mb-1" style="font-size: 10px;">Qtd Produzida</small>
                <h5 class="mb-0 font-weight-bold">{{ formatarQuantidade(detalheSelecionado.processo.QUANT_PRODUZIDA) }} {{ detalheSelecionado.processo.UNIDADE }}</h5>
                <small class="text-white-50">Total: {{ formatarMoeda(calcularCustoTotal(detalheSelecionado)) }}</small>
              </div>
            </div>
          </div>

          <b-tabs content-class="mt-3" pills nav-class="bg-light p-1 rounded-pill mb-4 border shadow-xs">
            <b-tab active>
              <template #title>
                <div class="px-3"><i class="fa fa-cubes mr-1"></i> INSUMOS</div>
              </template>
              <div class="table-responsive">
                <table class="table table-hover table-striped border rounded overflow-hidden" style="font-size: 0.85rem;">
                  <thead class="bg-light">
                    <tr>
                      <th>Cód.</th>
                      <th>Insumo</th>
                      <th class="text-right">Qtd Real</th>
                      <th class="text-right">Custo Unit.</th>
                      <th class="text-right">Subtotal Real</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="insumo in detalheSelecionado.insumos" :key="insumo.ID">
                      <td>{{ insumo.PRODUTO_ID }}</td>
                      <td class="font-weight-bold">{{ insumo.PRODUTO_NOME }}</td>
                      <td class="text-right">{{ formatarQuantidade(insumo.QUANT_APONTADA) }}</td>
                      <td class="text-right">{{ formatarMoeda(insumo.CUSTO_UNITARIO) }}</td>
                      <td class="text-right text-info font-weight-bold">{{ formatarMoeda(insumo.CUSTO_TOTAL_REAL) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
            <b-tab>
              <template #title>
                <div class="px-3"><i class="fa fa-cog mr-1"></i> CUSTO OPERACIONAL</div>
              </template>
              <div class="table-responsive">
                <table class="table table-hover table-striped border rounded overflow-hidden" style="font-size: 0.85rem;">
                  <thead class="bg-light">
                    <tr>
                      <th>Centro de Custo</th>
                      <th class="text-right">Valor Rateado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="detalheSelecionado.custosOperacionais.length === 0">
                      <td colspan="2" class="text-center py-3 text-muted">Nenhum custo operacional rateado para este processo.</td>
                    </tr>
                    <tr v-for="op in detalheSelecionado.custosOperacionais" :key="op.ID">
                      <td class="font-weight-bold text-uppercase">{{ op.CENTRO_CUSTO }}</td>
                      <td class="text-right text-warning font-weight-bold">{{ formatarMoeda(op.VALOR_TOTAL) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
          </b-tabs>

          <div class="bg-light p-3 rounded border shadow-sm mt-4 d-flex flex-column flex-md-row justify-content-between align-items-center">
            <div class="text-muted small mb-3 mb-md-0">Análise gerada em: {{ new Date().toLocaleString() }}</div>
            <div class="d-flex gap-4 align-items-center">
              <div class="text-right px-3">
                <small class="text-muted d-block">Subtotal Insumos</small>
                <span class="font-weight-bold text-info">{{ formatarMoeda(somarInsumos(detalheSelecionado)) }}</span>
              </div>
              <div class="text-right px-3 border-left">
                <small class="text-muted d-block">Subtotal Operacional</small>
                <span class="font-weight-bold text-warning">{{ formatarMoeda(somarOperacional(detalheSelecionado)) }}</span>
              </div>
              <div class="text-right border-left pl-4">
                <small class="text-muted d-block">CUSTO TOTAL REAL</small>
                <h4 class="mb-0 font-weight-bold text-dark">{{ formatarMoeda(calcularCustoTotal(detalheSelecionado)) }}</h4>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as echarts from 'echarts'
import tools from '../../tools/tools'
import RelatorioHTML from '../../utils/RelatorioHTML'

export default {
  name: 'EstoqueAnaliseCustos',
  data() {
    return {
      loading: false,
      detalheSelecionado: null,
      filtros: {
        dt1: tools.getFirstDayOfMonth(),
        dt2: tools.getCurrentDate()
      },
      resumo: {
        valorTotalEstoque: 0,
        totalProdutosEstoque: 0,
        valorTotalProduzido: 0,
        totalProcessosFinalizados: 0,
        valorCustoOperacional: 0,
        totalNaturezas: 0,
        percentualCustoOp: 0
      },
      dadosGrupo: [],
      dadosCentro: [],
      historicoProducao: [],
      charts: {
        grupo: null,
        centro: null
      }
    }
  },
  mounted() {
    this.carregarDados()
    window.addEventListener('resize', this.resizeCharts)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCharts)
  },
  methods: {
    async carregarDados() {
      this.loading = true
      try {
        const [resGrupo, resCentro, resHistorico] = await Promise.all([
          axios.get('/api/protected/estoque/getValorizacaoEstoqueGrupo'),
          axios.get('/api/protected/estoque/getValorizacaoEstoqueCentro'),
          axios.get('/api/protected/estoque/getAnaliseCustoProducao', { params: this.filtros })
        ])

        this.dadosGrupo = resGrupo.data
        this.dadosCentro = resCentro.data
        this.historicoProducao = resHistorico.data

        this.calcularResumo()
        this.initCharts()
      } catch (error) {
        this.$toast.error('Erro ao carregar dados: ' + error.message)
      } finally {
        this.loading = false
      }
    },

    calcularResumo() {
      this.resumo.valorTotalEstoque = this.dadosGrupo.reduce((acc, i) => acc + i.VALOR_TOTAL, 0)
      this.resumo.totalProdutosEstoque = this.dadosGrupo.reduce((acc, i) => acc + i.QTD_PRODUTOS, 0)

      const custoTotalInsumos = this.historicoProducao.reduce((acc, i) => acc + (i.CUSTO_INSUMOS || 0), 0)
      this.resumo.valorCustoOperacional = this.historicoProducao.reduce((acc, i) => acc + (i.CUSTO_OPERACIONAL || 0), 0)
      this.resumo.valorTotalProduzido = custoTotalInsumos + this.resumo.valorCustoOperacional
      this.resumo.totalProcessosFinalizados = this.historicoProducao.length
      
      this.resumo.percentualCustoOp = this.resumo.valorTotalProduzido > 0 
        ? (this.resumo.valorCustoOperacional / this.resumo.valorTotalProduzido) * 100 
        : 0
    },

    initCharts() {
      this.$nextTick(() => {
        this.initChartGrupo()
        this.initChartCentro()
      })
    },

    initChartGrupo() {
      const chartDom = document.getElementById('chartGrupo')
      if (!chartDom) return
      if (this.charts.grupo) this.charts.grupo.dispose()
      this.charts.grupo = echarts.init(chartDom)
      const data = this.dadosGrupo.slice(0, 5).map(i => ({ value: i.VALOR_TOTAL, name: i.GRUPO }))
      const option = {
        tooltip: { trigger: 'item', formatter: '{b}: <b>{c}</b> ({d}%)' },
        series: [{
          type: 'pie', radius: ['40%', '70%'],
          itemStyle: { borderRadius: 5, borderColor: '#fff', borderWidth: 2 },
          label: { show: false },
          data: data
        }]
      }
      this.charts.grupo.setOption(option)
    },

    initChartCentro() {
      const chartDom = document.getElementById('chartCentro')
      if (!chartDom) return
      if (this.charts.centro) this.charts.centro.dispose()
      this.charts.centro = echarts.init(chartDom)
      const option = {
        grid: { left: '3%', right: '4%', bottom: '3%', top: '5%', containLabel: true },
        xAxis: { type: 'value', axisLabel: { fontSize: 10 }, splitLine: { lineStyle: { color: '#eee' } } },
        yAxis: { type: 'category', data: this.dadosCentro.map(i => i.CENTRO), axisLabel: { fontSize: 10 } },
        series: [{
          type: 'bar', data: this.dadosCentro.map(i => i.VALOR_TOTAL),
          itemStyle: { color: '#4e73df', borderRadius: [0, 5, 5, 0] }
        }]
      }
      this.charts.centro.setOption(option)
    },

    resizeCharts() {
      if (this.charts.grupo) this.charts.grupo.resize()
      if (this.charts.centro) this.charts.centro.resize()
    },

    formatarMoeda(val) { return tools.formatCurrency(val || 0) },
    formatarData(val) { return tools.formatarDataBR(val) },
    formatarQuantidade(val) { return (val || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 }) },
    formatarPercentual(val) { return (val || 0).toFixed(1) + '%' },

    async abrirEspelhoCusto(item) {
      this.loading = true
      try {
        const { data } = await axios.get('/api/protected/estoque/getDetalheCustoProducao', { 
          params: { processoId: item.PROCESSO_ID } 
        })
        this.detalheSelecionado = data
        this.$refs.modalDetalhe.show()
      } catch (error) {
        this.$toast.error('Erro ao carregar detalhes: ' + error.message)
      } finally {
        this.loading = false
      }
    },

    somarInsumos(detalhe) {
      return (detalhe.insumos || []).reduce((acc, i) => acc + (i.CUSTO_TOTAL_REAL || 0), 0)
    },

    somarOperacional(detalhe) {
      return (detalhe.custosOperacionais || []).reduce((acc, i) => acc + (i.VALOR_TOTAL || 0), 0)
    },

    calcularCustoTotal(detalhe) {
      return this.somarInsumos(detalhe) + this.somarOperacional(detalhe)
    },

    exportarExcel() {
      RelatorioHTML.exportExcelXlsx({ 
        rows: this.historicoProducao, 
        columns: [
          { key: 'PROCESSO_ID', label: 'ID', type: 'number' },
          { key: 'PRODUTO_ACABADO', label: 'Produto' },
          { key: 'DATA_FINALIZACAO', label: 'Data', type: 'date' },
          { key: 'QUANT_PRODUZIDA', label: 'Qtd', type: 'number' },
          { key: 'CUSTO_INSUMOS', label: 'C. Insumos', type: 'currency' },
          { key: 'CUSTO_OPERACIONAL', label: 'C. Operac', type: 'currency' }
        ],
        filename: 'Analise_Custos_Producao.xlsx'
      })
    },

    exportarCsv() {
      RelatorioHTML.exportCsv({
        rows: this.historicoProducao,
        columns: [
          { key: 'PROCESSO_ID', label: 'ID' },
          { key: 'PRODUTO_ACABADO', label: 'Produto' },
          { key: 'DATA_FINALIZACAO', label: 'Data', type: 'date' },
          { key: 'QUANT_PRODUZIDA', label: 'Qtd', type: 'number' },
          { key: 'CUSTO_INSUMOS', label: 'C. Insumos', type: 'currency' },
          { key: 'CUSTO_OPERACIONAL', label: 'C. Operac', type: 'currency' }
        ],
        filename: 'Analise_Custos_Producao.csv'
      })
    },

    imprimirListagem() {
      const corpo = this.historicoProducao.map((i, index) => `
        <tr>
          <td>${index + 1}</td>
          <td>#${i.PROCESSO_ID}</td>
          <td>${i.PRODUTO_ACABADO}</td>
          <td>${this.formatarData(i.DATA_FINALIZACAO)}</td>
          <td align="right">${this.formatarQuantidade(i.QUANT_PRODUZIDA)}</td>
          <td align="right">${this.formatarMoeda(i.CUSTO_INSUMOS)}</td>
          <td align="right">${this.formatarMoeda(i.CUSTO_OPERACIONAL)}</td>
          <td align="right"><b>${this.formatarMoeda(i.CUSTO_INSUMOS + i.CUSTO_OPERACIONAL)}</b></td>
        </tr>
      `).join('')

      const html = `
        <table class="grid">
          <thead>
            <tr>
              <th width="40">#</th>
              <th width="80">Proc.</th>
              <th>Produto Acabado</th>
              <th width="100">Finalização</th>
              <th width="100" align="right">Qtd</th>
              <th width="100" align="right">Insumos</th>
              <th width="100" align="right">Operacional</th>
              <th width="110" align="right">Total</th>
            </tr>
          </thead>
          <tbody>${corpo}</tbody>
        </table>
      `
      RelatorioHTML.imprimir(html, 'Listagem de Custos de Produção', 'A4', 'landscape')
    },

    imprimirEspelhoCusto(detalhe) {
      const linhasInsumos = detalhe.insumos.map((i, idx) => `
        <tr>
          <td>${idx + 1}</td>
          <td>${i.PRODUTO_ID}</td>
          <td>${i.PRODUTO_NOME}</td>
          <td align="right">${this.formatarQuantidade(i.QUANT_APONTADA)}</td>
          <td align="right">${this.formatarMoeda(i.CUSTO_UNITARIO)}</td>
          <td align="right">${this.formatarMoeda(i.CUSTO_TOTAL_REAL)}</td>
        </tr>
      `).join('')

      const linhasOp = detalhe.custosOperacionais.map((i, idx) => `
        <tr>
          <td>${idx + 1}</td>
          <td>${i.CENTRO_CUSTO}</td>
          <td align="right">${this.formatarMoeda(i.VALOR_TOTAL)}</td>
        </tr>
      `).join('')

      const html = `
        <div style="padding: 10px; border: 1px solid #ddd; margin-bottom: 20px;">
          <table width="100%">
            <tr>
              <td width="50%"><b>PROCESSO:</b> #${detalhe.processo.ID} (Lote: ${detalhe.processo.LOTE})</td>
              <td width="50%" align="right"><b>DATA:</b> ${this.formatarData(detalhe.processo.DATA_FINALIZACAO || detalhe.processo.DATA_PROCESSO)}</td>
            </tr>
            <tr>
              <td colspan="2"><b>PRODUTO:</b> ${detalhe.processo.PRODUTO_NOME}</td>
            </tr>
            <tr>
              <td><b>QTD PRODUZIDA:</b> ${this.formatarQuantidade(detalhe.processo.QUANT_PRODUZIDA)} ${detalhe.processo.UNIDADE}</td>
              <td align="right"><b>CUSTO TOTAL:</b> ${this.formatarMoeda(this.calcularCustoTotal(detalhe))}</td>
            </tr>
          </table>
        </div>

        <h3>Insumos / Matéria-Prima</h3>
        <table class="grid">
          <thead>
            <tr>
              <th width="40">#</th>
              <th width="80">Cód.</th>
              <th>Descrição Insumo</th>
              <th width="100" align="right">Qtd Real</th>
              <th width="110" align="right">Unit.</th>
              <th width="120" align="right">Subtotal</th>
            </tr>
          </thead>
          <tbody>${linhasInsumos}</tbody>
          <tfoot>
            <tr>
              <td colspan="5" align="right"><b>Total Insumos:</b></td>
              <td align="right"><b>${this.formatarMoeda(this.somarInsumos(detalhe))}</b></td>
            </tr>
          </tfoot>
        </table>

        <h3>Custos Operacionais Rateados</h3>
        <table class="grid">
          <thead>
            <tr>
              <th width="40">#</th>
              <th>Centro de Custo</th>
              <th width="150" align="right">Valor Rateado</th>
            </tr>
          </thead>
          <tbody>${linhasOp}</tbody>
          <tfoot>
            <tr>
              <td colspan="2" align="right"><b>Total Operacional:</b></td>
              <td align="right"><b>${this.formatarMoeda(this.somarOperacional(detalhe))}</b></td>
            </tr>
          </tfoot>
        </table>

        <div style="margin-top: 30px; border-top: 2px solid #333; padding-top: 10px; text-align: right;">
          <h2 style="margin:0;">CUSTO TOTAL FINAL: ${this.formatarMoeda(this.calcularCustoTotal(detalhe))}</h2>
          <p>Custo Unitário Real: ${this.formatarMoeda(this.calcularCustoTotal(detalhe) / (detalhe.processo.QUANT_PRODUZIDA || 1))}</p>
        </div>
      `
      RelatorioHTML.imprimir(html, 'Espelho de Custo Real de Produção', 'A4', 'portrait')
    }
  }
}
</script>

<style scoped>
.page-col { background-color: #f4f6f9; min-height: 100vh; }
.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.2rem;
}
.icon-circle {
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bg-primary-soft { background-color: #f0f3ff; }
.bg-success-soft { background-color: #e8faf4; }
.bg-warning-soft { background-color: #fff9e6; }
.border-left-primary { border-left: 4px solid #4e73df; }
.border-left-success { border-left: 4px solid #1cc88a; }
.border-left-warning { border-left: 4px solid #f6c23e; }
.search-pill-responsive { max-height: 50px; }
.btn-icon-only { width: 35px; height: 35px; display: flex; align-items: center; justify-content: center; }
.shadow-xs { box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); }
</style>



// WEBPACK FOOTER //
// src/views/estoque/EstoqueAnaliseCustos.vue